module.exports = __webpack_public_path__ + "img/logo.b8c6a9f7.png";